import * as React from 'react';
import { DEFAULT_SIZE, DEFAULT_COLOR } from '../types';
import { roundTo } from '../util';
import { Child, StyledFoldingCube } from './styles';
const FoldingCube = ({ size = DEFAULT_SIZE, color = DEFAULT_COLOR, className, }) => {
    const duration = 2.4;
    const range = duration / 2;
    const cubeCount = 4;
    const cubes = [0, 1, 3, 2].map(v => (React.createElement(Child, { scale: 90 * v, key: v, delay: roundTo((range / cubeCount) * v, 2), duration: duration })));
    return (React.createElement(StyledFoldingCube, { className: className, size: size, color: color }, cubes));
};
export default FoldingCube;
//# sourceMappingURL=index.js.map